import React, { useEffect, useState } from "react";
import Loading from "../Modals/Loading";
import priceListService from "../Services/priceListService";
import moment from "moment";

const PriceList = () => {
  const [loading, setLoading] = useState(false);
  const [PriceList, setPricelist] = useState([]);

  useEffect(() => {
    const getPrices = async () => {
      try {
        setLoading(true);
        const response = await priceListService.fetchAll();
        setPricelist(response.priceList);
        setLoading(false);
        console.log(PriceList);
      } catch {}
    };
    getPrices();
  }, []);

  return (
    <div className="mx-16 my-4">
      <div className=" flex flex-col">
        {loading ? (
          <div>
            <Loading />
          </div>
        ) : (
          <div className="my-10 border border-gray-200 rounded-xl">
            {PriceList.length > 0 ? (
              <table className="w-full rounded-xl shadow-lg shadow-gray-300">
                <thead className="bg-primary border-b-2 border-primary">
                  <tr className="uppercase text-sm text-left leading-normal w-full text-white">
                    <th className="rounded-tl-lg p-2 text-[13px] w-[1%]">Id</th>
                    <th className="py-4 pl-2 text-[13px] w-[3%]">Supplier</th>
                    <th className="py-4 text-[13px] w-[2%]">Brand</th>
                    <th className="py-4 text-[13px] w-[2%]">Vendor Code</th>
                    <th className="py-4 text-[13px] w-[3%]">Product</th>
                    <th className="py-4 text-[13px] w-[3%]">Date</th>
                    <th className="py-4 text-[13px] w-[2%] text-center">
                      Order Price
                    </th>
                    <th className="py-4 text-[13px] w-[2%] text-center">
                      Retail Price
                    </th>
                    <th className="rounded-tr-lg p-5 text-center text-[13px] w-[1%]">
                      Quantity
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {PriceList?.map((data, index) => (
                    <tr
                      key={index}
                      className="border-b border-gray-100 text-xs text-left"
                    >
                      <th className="py-4 text-center text-blue-500 font-bold w-[1%]">
                        {data.id}.
                      </th>
                      <th className="py-4 pl-2 text-primary font-semibold w-[3%]">
                        {data.supplier_name}
                      </th>
                      <th className="py-4 w-[2%] font-light">
                        {data.product_brand}
                      </th>
                      <th className="p-1 w-[2%] font-light">
                        {data.vendor_code}
                      </th>
                      <th className="p-1 w-[3%] font-light">
                        {data.product_title}
                      </th>
                      <th className="p-1 font-light w-[3%]">
                        {moment(data.date).format("LL")}
                      </th>
                      <th className="p-1 text-center font-semibold w-[2%]">
                        {data.order_price}
                      </th>
                      <th className="p-1 text-center font-semibold w-[2%]">
                        {data.price}
                      </th>
                      <th className="p-1 text-center font-light w-[1%]">
                        {data.quantity}
                      </th>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              "No Price List"
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default PriceList;
